module.exports = __webpack_public_path__ + "static/media/translations.1029.b4a9c574.resx";